import React, { FunctionComponent } from 'react';
import { Modal, ModalHeader, ModalContent } from 'ui/molecules/modal';
import Translate from 'ui/atoms/translate';
import PublicationsHistoryTable from '../publications-history-table';

export interface PublicationsHistoryModalProps {
  id: string;
  isin?: string | null;
  onModalClose: () => void;
}

const PublicationsHistoryModal: FunctionComponent<PublicationsHistoryModalProps> = (props) => {
  const { onModalClose, id, isin } = props;

  return (
    <Modal onClose={onModalClose} size="large">
      <ModalHeader>
        <Translate name="publications.historyModal.title" args={[isin]} />
      </ModalHeader>
      <ModalContent>
        <p>
          <Translate name="publications.historyModal.subtitle" />
        </p>
        <PublicationsHistoryTable productId={id} />
      </ModalContent>
    </Modal>
  );
};

export default PublicationsHistoryModal;
